import { html } from 'htm/preact';

/**
 * A altura do Sol acima do horizonte no máximo do eclipse — o segundo facto mais
 * importante da peça, depois da percentagem.
 *
 * Em toda a Ibéria o Sol está entre ~2° e ~15° no momento do máximo. Isso é baixo o
 * suficiente para que uma serra, um edifício ou uma linha de árvores tapem o eclipse
 * por completo, e é a razão pela qual esta informação merece um cartão e não uma
 * linha de texto: escrever "10°" não faz ninguém perceber quão rasante isso é;
 * desenhar 10° sobre um horizonte com serra, faz.
 *
 * A escala vai a 30° porque é onde o Sol está no início do eclipse nos concelhos mais
 * a norte — fixar o topo mantém os cartões de concelhos diferentes comparáveis entre si.
 */

const SCALE_MAX_DEG = 30;
const W = 260;
const H = 108;
const HORIZON_Y = 84;

/** Perfil de serra, em fracções da largura — decorativo, mas propositadamente com
 *  cumes de altura plausível (~3°-4°) para o leitor perceber a ordem de grandeza do
 *  obstáculo que basta para lhe tapar o eclipse. */
const RIDGE = 'M0,84 L18,79 L34,81 L52,73 L72,78 L96,70 L120,77 L146,72 L168,80 L190,74 L214,80 L236,76 L260,82 L260,108 L0,108 Z';

export function HorizonCard({ altitudeDeg, label }: { altitudeDeg: number; label: string }) {
    const clamped = Math.max(0, Math.min(SCALE_MAX_DEG, altitudeDeg));
    const y = HORIZON_Y - (clamped / SCALE_MAX_DEG) * (HORIZON_Y - 14);
    const ticks = [10, 20, 30];

    return html`
        <div class="eclipse-card eclipse-card--horizon">
            <p class="eclipse-card__title">Altura do Sol no máximo</p>
            <svg class="eclipse-horizon" viewBox=${`0 0 ${W} ${H}`} role="img" aria-label=${`No máximo, o Sol estará a cerca de ${Math.round(altitudeDeg)} graus acima do horizonte.`}>
                ${ticks.map(t => {
                    const ty = HORIZON_Y - (t / SCALE_MAX_DEG) * (HORIZON_Y - 14);
                    return html`
                        <g key=${t}>
                            <line x1="0" y1=${ty} x2=${W} y2=${ty} class="eclipse-horizon__tick" />
                            <text x=${W - 2} y=${ty - 3} class="eclipse-horizon__tick-label" text-anchor="end">${t}°</text>
                        </g>
                    `;
                })}
                <line x1="0" y1=${HORIZON_Y} x2=${W} y2=${HORIZON_Y} class="eclipse-horizon__line" />
                <path d=${RIDGE} class="eclipse-horizon__ridge" />
                <circle cx="86" cy=${y} r="9" class="eclipse-horizon__sun" />
                <line x1="0" y1=${y} x2="72" y2=${y} class="eclipse-horizon__sun-line" />
                <text x="4" y=${y - 6} class="eclipse-horizon__sun-label">${label}</text>
            </svg>
        </div>
    `;
}
